import {memo, useMemo} from 'react';

import {getAvatarImage} from '@/utils/getAvatarImage';
import {getInitials} from '@/utils/getInitials';

export const InviterAvatar = memo(
  ({inviterName}: {inviterName?: string | null}) => {
    return useMemo(() => {
      if (!inviterName) return null;

      const initials = getInitials(inviterName);
      return getAvatarImage(undefined, initials);
    }, [inviterName]);
  },
);
